import React from "react";
import {
  AreaChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Area,
} from "recharts";
import { ChartStrategy } from "./ChartStrategy";
import { DYCHARTCOLORS } from "../../../../core/constants/chartStyles";

export class AreaChartStrategy extends ChartStrategy {
  render() {
    return (
      <AreaChart {...this.commonProps}>
        <CartesianGrid stroke={this.props.gridColor} strokeDasharray="3 3" />
        <XAxis dataKey={this.props.xAxis} {...this.axisProps} />
        <YAxis {...this.axisProps} />
        <Tooltip content={<this.props.CustomTooltip />} />
        <Area
          dataKey={this.props.yAxis}
          fill={DYCHARTCOLORS[0]}
          stroke={DYCHARTCOLORS[0]}
        />
      </AreaChart>
    );
  }
}
